import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import { ButtonView } from "../../components/ButtonView";
import {
  color_333333,
  color_BEBEBE,
  color_E9E9E9,
  color_main,
  ColorRed,
  transparent,
  white,
} from "../../assets/style/colors";
import { MainNavProps } from "../navigation/main/MainParamList";
import { FlatList, Image, Pressable, View } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { Emoticon } from "../../../imsdk/db/t_emoticon";
import * as ImSdk from "../../../imsdk/api";
import FastImage from "react-native-fast-image";
import {
  Str_AddAddedSingleEmoticon,
  Str_AddSucc,
  Str_Cancel,
  Str_Delete,
  Str_DeleteSucc,
  Str_Tidy,
} from "../../language/string_res";
import { useWindowDimensions } from "react-native";
import { openSinglePicker } from "../../utils/PicOrCameraManager";
import { hideLoading, showLoading } from "../../components/Loading";
import { uploadImages } from "../../utils/upload";
import { showToast } from "../../components/Toast";
import globalEventBus from "../../utils/EventBus";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { CheckBoxView } from "../../components/CheckBoxView";
import { fixRemoteUrl } from "../../../imsdk/api";
import { UploadKey } from "../../utils/ReactBlobUtil";
import MediaPlaceholder from "../../components/MediaPlaceholder";

const pageSize = 300;

export const CollectImageManagerScreen = ({
  navigation,
  route,
}: MainNavProps<"CollectImageManagerScreen">) => {
  const { width: screenWidth } = useWindowDimensions();
  const width = (screenWidth - 6 * 5) / 4;
  const add: Emoticon = { id: "-1", url: "", ctime: 0 };
  const [data, setData] = useState([add]);
  const loading = useRef(false);
  const [hasMore, setHasMore] = useState(true);
  const [select, setSelect] = useState<Emoticon[]>([]);
  const [showSelect, setShowSelect] = useState(false);
  const showSelectRef = useRef(false);
  const insets = useSafeAreaInsets();

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    showSelectRef.current = showSelect;
  }, [showSelect]);

  function fetchData() {
    loading.current = true;
    ImSdk.getInstance()
      .GetEmoticonList(data.length - 1, pageSize)
      .then((r) => {
        if (r.emoticons && r.emoticons.length > 0) {
          const result = r.emoticons;
          // const result = r.emoticons.reverse();
          setHasMore(pageSize === result.length);
          setData((prevState) => [...prevState, ...result]);
        }
      })
      .finally(() => {
        loading.current = false;
      });
  }

  function loadMore() {
    if (data.length - 1 === 0 || !hasMore || loading.current) {
      return;
    }
    fetchData();
  }

  function addEmoticon() {
    if (showSelect) return;
    openSinglePicker("photo", true).then((r) => {
      if (r) {
        showLoading();
        uploadImages([r], UploadKey.Emoticon).then((r) => {
          if (r.responses && r.responses.length > 0) {
            const n = r.responses.length;
            for (let i = 0; i < n; i++) {
              const res = r.responses[i];

              // 获取图片 URL
              let imageUrl = res.url;

              // 检查 URL 是否已经包含 width 和 height 参数
              const hasWidthParam =
                imageUrl.includes("width=") || imageUrl.includes("&width=");
              const hasHeightParam =
                imageUrl.includes("height=") || imageUrl.includes("&height=");

              // 如果 URL 中没有尺寸参数，且响应中有尺寸信息，则拼接尺寸参数
              if (
                (!hasWidthParam || !hasHeightParam) &&
                res.width &&
                res.height
              ) {
                // 检查 URL 是否已有查询参数
                const hasQuery = imageUrl.includes("?");

                // 拼接尺寸参数
                if (!hasWidthParam) {
                  const separator = hasQuery ? "&" : "?";
                  imageUrl += `${separator}width=${res.width}`;
                }
                if (!hasHeightParam) {
                  // 如果已经拼接了 width 或者 URL 中已有查询参数，使用 &，否则使用 ?
                  const separator = imageUrl.includes("?") ? "&" : "?";
                  imageUrl += `${separator}height=${res.height}`;
                }
              }

              ImSdk.getInstance()
                .AddEmoticon(imageUrl)
                .then((r) => {
                  let msg: string;
                  if (r.emoticon) {
                    msg = Str_AddSucc;
                    const e = r.emoticon;
                    setData((prevState) => [
                      ...prevState.slice(0, 1),
                      e,
                      ...prevState.slice(1),
                    ]);
                    globalEventBus.emit("AddEmoticon", e);
                  } else {
                    msg = r.error;
                  }
                  showToast(msg);
                  hideLoading();
                });
            }
          } else {
            hideLoading();
          }
        });
      }
    });
  }

  function delEmoticon() {
    if (!(select.length > 0)) return;
    showLoading();
    const ids = select.map((value) => value.id);
    ImSdk.getInstance()
      .DelEmoticon(ids)
      .then((r) => {
        if (r.error) {
          showToast(r.error);
        } else {
          showToast(Str_DeleteSucc);
          setData((prevData) => prevData.filter((v) => !ids.includes(v.id)));
          globalEventBus.emit("DeleteEmoticon", ids);
          setShowSelect(false);
        }
      })
      .finally(() => {
        hideLoading();
      });
  }

  const updateItem = (data: Emoticon) => {
    if (!showSelect) return;
    if (select.includes(data)) {
      setSelect((prevState) => prevState.filter((value) => value != data));
    } else {
      setSelect((prevState) => [...prevState, data]);
    }
  };

  const ImagePopover = React.memo(
    ({
      item,
      onUpdate,
    }: {
      item: Emoticon;
      onUpdate: (data: Emoticon) => void;
    }) => {
      const [isLoading, setIsLoading] = useState(true);
      const [isLoadError, setIsLoadError] = useState(false);
      const [retryCount, setRetryCount] = useState(0);

      const handleLoadEnd = () => {
        setIsLoading(false);
      };

      const onLoadStart = () => {
        setIsLoading(true);
        setIsLoadError(false);
      };

      const handleLoadError = () => {
        setIsLoading(false);
        setIsLoadError(true);
      };

      const handleRetry = () => {
        if (isLoading || !isLoadError) {
          return;
        }
        setRetryCount((prev) => prev + 1);
      };

      return (
        <Pressable
          style={{
            marginStart: 6,
            backgroundColor: white,
            width: width,
            height: width,
            padding: 10,
            borderRadius: 6,
            alignItems: "center",
            justifyContent: "center",
          }}
          onPress={() => onUpdate(item)}
        >
          <FastImage
            key={`${item.url}_${retryCount}`}
            style={{ width: width, height: width, borderRadius: 6 }}
            onLoadEnd={handleLoadEnd}
            onLoadStart={onLoadStart}
            onError={handleLoadError}
            resizeMode={"cover"} 
            source={{
              uri: fixRemoteUrl(item.url),
              priority: FastImage.priority.normal,
              cache: FastImage.cacheControl.immutable,
            }}
          />

          {(isLoading || isLoadError) && (
            <View
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: width,
                height: width,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <MediaPlaceholder
                type={"image"}
                status={!isLoading && isLoadError ? "error" : "loading"}
                width={width}
                height={width}
                marginVertical={0}
                showReroad={false}
                onPress={handleRetry}
              />
            </View>
          )}

          {showSelect &&
            <View style={{
              position: "absolute",
              top: (width - 32) * 0.5,
              left: (width - 32) * 0.5,
              width: 32,
              height: 32,
              backgroundColor: white,
              borderRadius: 16
            }}>
              <CheckBoxView
                disabled={true}
                value={select.includes(item)}
                style={{
                  width: 32,
                  height: 32,
                }}
              />
            </View>
          }
        </Pressable>
      );
    },
    (prevProps, nextProps) => {
      return prevProps.item == nextProps.item;
    }
  );

  const renderItem = ({ item, index }: { item: Emoticon; index: number }) => {
    if (index === 0) {
      return (
        <Pressable
          style={{
            marginStart: 6,
            alignItems: "center",
            backgroundColor: white,
            borderRadius: 6,
            width: width,
            height: width,
            justifyContent: "center",
          }}
          onPress={addEmoticon}
        >
          <View
            style={{
              start: 26,
              end: 26,
              height: 3,
              backgroundColor: color_BEBEBE,
              position: "absolute",
            }}
          />
          <View
            style={{
              top: 26,
              bottom: 26,
              width: 3,
              backgroundColor: color_BEBEBE,
              position: "absolute",
            }}
          />
        </Pressable>
      );
    }

    return <ImagePopover item={item} onUpdate={updateItem} />;
  };

  const rightOnClick = () => {
    const current = showSelectRef.current;
    setShowSelect(!current);
    setSelect([]);
  };
  return (
    <BaseScreen
      styles={{ backgroundColor: transparent }}
      statusBarColor={white}
    >
      <NavBar
        style={{ backgroundColor: white, marginBottom: 6 }}
        showBack={true}
        title={Str_AddAddedSingleEmoticon}
        rightClick={rightOnClick}
        rightChildren={
          <ButtonView
            onPress={rightOnClick}
            text={showSelect ? Str_Cancel : Str_Tidy}
            textStyle={{ color: color_333333, fontSize: 16 }}
          />
        }
      />
      <FlatList
        data={data}
        renderItem={renderItem}
        numColumns={4}
        onEndReached={loadMore}
        onEndReachedThreshold={0.2}
        keyExtractor={(item, index) => {
          return `${index}_${item.id}_${item.ctime}`;
        }}
        ItemSeparatorComponent={() => <View style={{ height: 6 }} />}
      />
      {showSelect && (
        <View
          style={{
            flexDirection: "row-reverse",
            paddingBottom: insets.bottom,
            backgroundColor: color_E9E9E9,
          }}
        >
          <View
            style={{
              height: 0.5,
              position: "absolute",
              top: 0,
              start: 0,
              end: 0,
              backgroundColor: color_BEBEBE,
            }}
          />
          <ButtonView
            text={`${Str_Delete} (${select.length}) `}
            onPress={delEmoticon}
            style={{ padding: 16 }}
            textStyle={{ color: ColorRed, fontSize: 16 }}
          />
        </View>
      )}
    </BaseScreen>
  );
};
